import { css } from '@emotion/react';
import styled from '@emotion/styled';
import propTypes from '@styled-system/prop-types';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import {
  border,
  color,
  compose,
  flexbox,
  layout,
  position,
  space,
} from 'styled-system';

import { forwardValidProp } from '../../utils/style';

const StyledFlex = styled('div', {
  shouldForwardProp: (prop) => forwardValidProp(prop),
})`
  ${({ flexDisplay }) => css`
    display: ${flexDisplay};
  `}
  ${({ full }) =>
    full &&
    css`
      width: 100%;
    `}
  ${compose(border, color, flexbox, layout, space, position)}
`;

const Flex = forwardRef(({ ...rest }, ref) => (
  <StyledFlex ref={ref} {...rest} />
));

Flex.displayName = 'Flex';

Flex.defaultProps = {
  flexDisplay: 'flex',
  full: false,
  children: null,
};

Flex.propTypes = {
  /**
   * Components to be rendered as children
   */
  children: PropTypes.node,
  /**
   * Renders component with one of the following displays
   */
  flexDisplay: PropTypes.oneOf(['flex', 'inline-flex']),
  /**
   * Flex fills the parent component's width
   */
  full: PropTypes.bool,
  // visibility: PropTypes.oneOf(['visible', 'hidden', 'collapse']),
  /**
   * Implements `styled-system` [border](https://styled-system.com/api/#border) utility
   */
  ...propTypes.border,
  /**
   * Implements `styled-system` [color](https://styled-system.com/api/#color) utility
   */
  ...propTypes.color,
  /**
   * Implements `styled-system` [flexbox](https://styled-system.com/api/#flexbox) utility
   */
  ...propTypes.flexbox,
  /**
   * Implements `styled-system` [layout](https://styled-system.com/api/#layout) utility
   */
  ...propTypes.layout,
  /**
   * Implements `styled-system` [space](https://styled-system.com/api/#space) utility
   */
  ...propTypes.space,
  /**
   * Implements `styled-system` [position](https://styled-system.com/api/#position) utility
   */
  ...propTypes.position,
};

export default Flex;
